import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { t } from '@lingui/macro';
import { CourseNameWrapper, CourseNameLabel, CourseNameTitle } from './styled';

const CourseName = ({ i18n }) => {
  const activeClass = useSelector(
    (state) => state.CourseAssignReducer.activeClass
  );

  const activeGroup = useSelector(
    (state) => state.CourseAssignReducer.activeGroup
  );

  const courseName = useSelector(
    (state) =>
      state.CourseAssignReducer.classrooms
        ?.find((classroom) => classroom.classroomId === activeClass)
        ?.groups.find((group) => group.groupId === activeGroup)?.courseName
  );

  return (
    <CourseNameWrapper>
      <CourseNameLabel>{i18n._(t('coursename')`Course Name`)}</CourseNameLabel>
      <CourseNameTitle data-testid="filter-course-name">
        {courseName}
      </CourseNameTitle>
    </CourseNameWrapper>
  );
};

CourseName.propTypes = {
  i18n: PropTypes.object
};

export default CourseName;



// WEBPACK FOOTER //
// ./components/course-name/index.js